import { apiClient as api } from "./httpClient";

export interface PrintTemplate {
  id: string;
  title: string;
  entity?: string;
  file?: string; // logo em base64 (data URI)
  header?: string; // HTML do cabeçalho
  footer?: string; // HTML do rodapé
  status: boolean;
  isDefault: boolean; // template padrão da entidade (apenas um por entidade)
}

export interface PrintTemplatePayload {
  title: string;
  file?: string;
  header?: string;
  footer?: string;
}

/**
 * Cabeçalho e rodapé dos templates vieram do Bubble com marcação BBCode ([b], [i], [u]) e
 * quebras gravadas como a sequência barra-n literal — sem traduzir, o documento impresso
 * mostra "[b]INSTITUTO NINHO[/b]" na cara do paciente (achado do Hilton, 31/08).
 * Templates novos, que já vêm em HTML, passam intactos.
 */
export const renderTemplateHtml = (raw?: string | null): string => {
  const bbcode = /\[(b|i|u)\]([\s\S]*?)\[\/\1\]/gi;
  const tags: Record<string, string> = { b: 'strong', i: 'em', u: 'u' };

  return (raw || '')
    .split(String.fromCharCode(92) + 'n').join('<br />')
    .split(String.fromCharCode(10)).join('<br />')
    .replace(bbcode, (_m, tag: string, inner: string) => {
      const html = tags[tag.toLowerCase()];
      return '<' + html + '>' + inner + '</' + html + '>';
    });
};

export const printTemplateService = {
  getByEntity: async (entityId: string): Promise<PrintTemplate[]> => {
    const response = await api.get(`/print-templates/by-entity/${entityId}`);
    return Array.isArray(response.data) ? response.data : [];
  },
  create: async (
    entityId: string,
    data: PrintTemplatePayload
  ): Promise<string> => {
    const response = await api.post(`/print-templates`, { entityId, ...data });
    return response.data;
  },
  update: async (id: string, data: PrintTemplatePayload): Promise<void> => {
    await api.put(`/print-templates/${id}`, data);
  },
  remove: async (id: string): Promise<void> => {
    await api.delete(`/print-templates/${id}`);
  },
  setDefault: async (id: string): Promise<void> => {
    await api.patch(`/print-templates/${id}/set-default`);
  },
  setStatus: async (id: string, status: boolean): Promise<void> => {
    await api.put(`/print-templates/${id}`, { status });
  },
};
